export const getFinalWidth = (width, activeTab) => {
    let result = width;
    if (activeTab === 'week') {
        if (width < 11) {
            return width + 11;
        } else if (width < 22) {
            return width - 10;
        } else {
            return width - 12;
        }
    }
    if (activeTab === 'month') {
        if (width < 7) {
            return width + 7;
        } else if (width < 14) {
            return width + 7;
        } else if (width < 21) {
            return width - 13;
        } else {
            return width - 16;
        }
    }
    return result;
};

export const getFinalWidthPosition = (width, activeTab) => {
    let result = width;
    if (activeTab === 'week') {
        if (width < 11) {
            return width + 1;
        } else if (width < 22) {
            return width + 1;
        } else {
            return width;
        }
    }
    if (activeTab === 'month') {
        if (width < 7) {
            return width + 1;
        } else if (width < 14) {
            return width + 1;
        } else if (width < 21) {
            return width + 1;
        } else {
            return width;
        }
    }
    return result;
};
